import { theme } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";

import { TESTIMONIALS } from "./constants";
import {
  TestimonialsContainer,
  CardsContainer,
  CardsSubContainer,
  CardBodyContainer,
  Card,
  CardHeader,
  CardSubheader,
  CardParagraph,
  CustomerAvatar,
} from "./styles";

export default function TestimonialsSection() {
  const { mobile } = useLayout();

  return (
    <TestimonialsContainer>
      <CardsContainer>
        {TESTIMONIALS.map((testimonialSection, index) => (
          <CardsSubContainer key={index}>
            {testimonialSection.map((testimonial, index) => (
              <Card
                key={index}
                style={{
                  backgroundColor: theme.colorsPalette.black.light,
                  flexDirection: mobile ? "column" : "row",
                  alignItems: mobile ? "center" : "unset",
                  padding: 32,
                  width: "calc(100% - 64px)",
                }}
              >
                <CustomerAvatar src={testimonial.avatar} />

                <CardBodyContainer>
                  <CardHeader>{testimonial.name}</CardHeader>

                  <CardSubheader>{testimonial.role}</CardSubheader>

                  <CardParagraph>{testimonial.description}</CardParagraph>
                </CardBodyContainer>
              </Card>
            ))}
          </CardsSubContainer>
        ))}
      </CardsContainer>
    </TestimonialsContainer>
  );
}
